import { ia } from 'lib/helpers/utility';

import { checkIsNestedKey, renderValue } from 'components/shared/ExpandableToolbar/lib/helpers';

import { getNestedKeys, getNewNestedValue } from './getNewNestedValue';

export const formatChangedValues = ({ activities }) => {
  return activities
    .map((activity, index) => {
      const { action, previousValues, currentValues } = activity;

      const isCreateRecord = action === 'create' && index === 0;
      const previousKeys = getNestedKeys(previousValues);

      if (isCreateRecord || !ia(previousKeys)) {
        return { ...activity, isCreateRecord, formattedChanges: [] };
      }

      const formattedChanges = previousKeys
        .map((key) => {
          const isNestedKey = checkIsNestedKey(key, previousValues || currentValues);

          const prevValueRaw = getNewNestedValue(key, previousValues);
          const currValueRaw = getNewNestedValue(key, currentValues);

          const prevValue = renderValue({ key, value: prevValueRaw });
          const currValue = renderValue({ key, value: currValueRaw });

          if (prevValue === currValue) return null;

          const valueLength = Math.max(
            (prevValue || '').toString().length,
            (currValue || '').toString().length
          );

          return {
            key,
            isNestedKey,
            prevValueRaw,
            currValueRaw,
            prevValue,
            currValue,
            valueLength // temporary used in sorting
          };
        })
        .filter(Boolean);

      if (!ia(formattedChanges)) {
        return;
      }

      return {
        ...activity,
        isCreateRecord,
        formattedChanges: formattedChanges
          .sort((a, b) => a.valueLength - b.valueLength)
          .map(({ valueLength: _, ...rest }) => rest)
      };
    })
    .filter(Boolean);
};
